import "./Products.module.css";
import Header from "@/reusable_sections/Header";
import CompactPageHeader from "./sections/CompactPageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import ProductFamilyGrid from "./sections/ProductFamilyGrid";
import BrowseByMaterial from "./sections/BrowseByMaterial";
import BrowseByBuyer from "./sections/BrowseByBuyer";
import ConfigureOrUpload from "./sections/ConfigureOrUpload";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <Header />
      <CompactPageHeader />
      <DirectAnswerBlock />
      <ProductFamilyGrid />
      <BrowseByMaterial />
      <BrowseByBuyer />
      <ConfigureOrUpload />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}